<script lang="ts">
	import { page } from '$app/state';
	import { formatPrice } from '$lib';

	const {
		price,
		language = page.data.store.language,
		currency = page.data.store.currency,
	}: {
		price: number;
		language?: string;
		currency?: string;
	} = $props();
</script>

{formatPrice(price, language, currency)}
